import { createImpressionEvent } from '../base';
import { LOYALTY_PARAMS } from '../constants';

export const createLoyaltyizationImpressionEvent = (type) =>
    createImpressionEvent(type, LOYALTY_PARAMS);
